// tslint:disable
export var TCSGileadCommOption;
(function (TCSGileadCommOption) {
    // Opt-In
    TCSGileadCommOption[TCSGileadCommOption["OptIn"] = 0] = "OptIn";
    // Opt-Out
    TCSGileadCommOption[TCSGileadCommOption["OptOut"] = 1] = "OptOut";
})(TCSGileadCommOption || (TCSGileadCommOption = {}));
TCSGileadCommOption['OPTIN'] = 0;
TCSGileadCommOption['OPTOUT'] = 1;
//# sourceMappingURL=TCSGileadCommOption.js.map